import CreatePackagesTable from "./CreatePackagesTable";
export default CreatePackagesTable;
